export const isStrategicPsServices = (rank?: string) => {
  return rank?.includes('SPSSP')
}
